import React from 'react';
import './App.css';

import { Container, Row, Col} from 'react-bootstrap';
import { Provider } from 'react-redux';
import store from '../store/index';

import Navbar from '../components/Navbar/navbar';
import Sidebar from '../components/Sidebar/sidebar';
import Footer from '../components/Footer/footer';
import Controls from '../components/Controls/controls';
import Editor from '../components/Editor/editor';

function App() {
  return (
    <Provider store={store} className="App">  
      <header className="App-header">

        {/* NAVBAR */}
        <Navbar />
        
        {/* CONTENT */}
        <Container fluid> 
          <Row>
            <Col md={5} lg={5} className='content'>   
              <Sidebar />  
              <Footer />
            </Col>
            <Col className='content'>
              <Editor />
              <Controls />
            </Col>
          </Row>
        </Container>
        
      </header>
    </Provider>
  );
}

export default App;
